import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { ModalService } from '../../services/modal.service';
import { ConfirmationDialogService } from '../confirmation-dialog/confirmation-dialog.service';
import { ModeloMediador } from '../../model/modelomediador';
import { CadastrosService } from '../../services/cadastros.service';

@Component({
  selector: 'app-modelomediador',
  templateUrl: './modelomediador.component.html',
  styleUrls: ['./modelomediador.component.scss']
})
export class ModeloMediadorComponent implements OnInit {

  movSub: Subscription;
  modelomediador: any[];
  fileReader: FileReader;
  fileToRead: File;

  constructor(
      private spinner: NgxSpinnerService,
      private modalService: ModalService,
      private cadastrosService: CadastrosService,
      private toastr: ToastrService,
      private confirmationDialogService: ConfirmationDialogService
  ){

  }

  ngOnInit() {
    this.getmodelomediadors();
  }

  async getmodelomediadors(){

    this.modelomediador = [];

    if (this.movSub && this.movSub.closed == false){
      this.movSub.unsubscribe();
    }

    if (!this.movSub || this.movSub.closed){

      this.spinner.show();

      this.movSub = this.cadastrosService.listar("modelomediador/list").subscribe(
        (result: any) =>{

          this.modelomediador =  result;
          console.log(result);

          this.spinner.hide();

       },error=>{
            console.log(error);
            this.spinner.hide();
       });

    }


  }

  ngOnDestroy(){
    if (this.movSub && this.movSub.closed == false){
      this.movSub.unsubscribe();
    }
  }

  novomodelomediador(){
    this.modalService.modalDetalhesModeloMediador.emit(null);
  }

  editar(modelomediador: ModeloMediador){
    this.modalService.modalDetalhesModeloMediador.emit(modelomediador);
  }

  excluir(modelomediador: ModeloMediador){

    this.confirmationDialogService.confirm('Confirmar?', 'Realmente deseja excluir ?')
      .then((confirmed) =>{

        if(confirmed){
          this.cadastrosService.excluir("modelomediador/delete", modelomediador).subscribe(
            (result) =>{

              this.toastr.success('Modelo Mediador excluído com sucesso!', 'Sucesso!');
              this.getmodelomediadors();
              console.log(result);

            },
            error=> {

              this.toastr.error(error.message, 'Erro!');
              console.log(error);

            }
          );
        }

      })
      .catch(() => {
        console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)')
      });

  }


}
